// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_ToggleLocationConnection_SetupAutomations_Content($location_id: uuid!, $app_id: uuid!, $connection_id: uuid!) {
  apps_automations(location_id: $location_id, app_id: $app_id) {
    id
    automations
  }
  apps_connections_by_pk(id: $connection_id) {
    id
    app {
      id
      properties: metadata(path: "connection.properties")
    }
    resources(where: { resource_id: { _eq: $location_id } }) {
      id
      properties
    }
  }
}

`